export function isDebugVistMode(search: string): boolean {
  const debug = new URLSearchParams(search).get("debug");
  return debug === "vist";
}
